import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';
import { StudentDocument } from '../shared/interfaces/student-document';
import { AppConfigService } from './app-config.service';
import { UpdateDocumentStatuses } from '../shared/interfaces/document';
import { ApiResponse } from '../shared/interfaces/api-response';
import {
  PlacementDocRequest,
  PlacementDocuments,
} from '../modules/placement/interfaces/placement-documents';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  config: IAppConfig;

  headers: HttpHeaders = new HttpHeaders({
    enctype: 'multipart/form-data',
    Accept: 'application/json',
  });

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public uploadDocument(formData: FormData): Observable<number[]> {
    return this.http
      .post<number[]>(
        `${this.config.apiUrl}/Document/UploadDocuments`,
        formData,
        {
          headers: this.headers,
        }
      )
      .pipe(catchError(this.handleError));
  }

  public uploadVarianceDocuments(formData: FormData): Observable<any> {
    return this.http
      .post<any>(`${this.config.apiUrl}/Document/UploadDoc`, formData, {
        headers: this.headers,
      })
      .pipe(catchError(this.handleError));
  }

  public deleteDocument(docId: number, comment: string): Observable<boolean> {
    return this.http
      .post<boolean>(
        `${this.config.apiUrl}/Document/DeleteDocument/${docId}/${comment}`,
        null
      )
      .pipe(catchError(this.handleError));
  }

  public getDocument(docId: number): Observable<Uint8Array> {
    return this.http
      .get<Uint8Array>(`${this.config.apiUrl}/Document/GetDocument/${docId}`)
      .pipe(catchError(this.handleError));
  }

  public getStudentDocuments(studentSk: string): Observable<StudentDocument[]> {
    return this.http
      .get<StudentDocument[]>(
        `${this.config.apiUrl}/Document/GetStudentDocuments/${studentSk}`
      )
      .pipe(catchError(this.handleError));
  }

  public getStudentDocumentsByID(
    studentId: string
  ): Observable<StudentDocument[] | any> {
    return this.http
      .get<StudentDocument[]>(
        `${this.config.apiUrl}/Document/GetStudentDocumentsByID/${studentId}`
      )
      .pipe(catchError(this.handleError));
  }

  public getKIPStudentDocuments(
    studentId: string
  ): Observable<StudentDocument[]> {
    return this.http
      .get<StudentDocument[]>(
        `${this.config.apiUrl}/Document/GetKIPStudentDocuments/${studentId}`
      )
      .pipe(catchError(this.handleError));
  }

  public getCaseActionDocuments(
    studentSk: string,
    caseActionSk: string
  ): Observable<StudentDocument[]> {
    return this.http
      .get<StudentDocument[]>(
        `${this.config.apiUrl}/Document/GetCaseActionDocuments/${studentSk}/${caseActionSk}`
      )
      .pipe(catchError(this.handleError));
  }

  public getAttendanceDocument(
    meetingSk: string,
    attendeesList: any
  ): Observable<any> {
    return this.http
      .post<any[]>(
        `${this.config.apiUrl}/DocumentGen/AttendanceDocument?meetingSk=${meetingSk}`,
        attendeesList
      )
      .pipe(catchError(this.handleError));
  }

  public updateDocumentStatuses(
    updateDocumentStatusesData: UpdateDocumentStatuses[]
  ): Observable<ApiResponse<UpdateDocumentStatuses>> {
    return this.http
      .post<ApiResponse<UpdateDocumentStatuses>>(
        `${this.config.apiUrl}/Document/UpdateDocumentStatuses`,
        updateDocumentStatusesData
      )
      .pipe(catchError(this.handleError));
  }

  public deleteDocumentsById(
    eiId: string,
    comment: string,
    studentSk: string
  ): Observable<boolean> {
    return this.http
      .post<boolean>(
        `${this.config.apiUrl}/Document/DeleteFolder/${eiId}/${studentSk}`,
        null
      )
      .pipe(catchError(this.handleError));
  }

  getPlacementDocuments(
    getDocPayload: PlacementDocRequest
  ): Observable<PlacementDocuments> {
    return this.http
      .post<PlacementDocuments>(
        `${this.config.apiUrl}/Document/GetPlacementDocuments`,
        getDocPayload
      )
      .pipe(catchError(this.handleError));
  }

  // Error handling
  handleError(error: any): Observable<never> {
    let errorMessage: string = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
